(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripController', FleetDailyTripController);

    FleetDailyTripController.$inject = ['$state', 'FleetDailyTrip', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils'];

    function FleetDailyTripController($state, FleetDailyTrip, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = { date: false };

        vm.filterDate = pagingParams.date ? DateUtils.convertLocalDateFromServer(pagingParams.date) : null;
        vm.filterTechnicien = pagingParams.technicien || '';
        vm.WITHOUT_TECHNICIEN = '__WITHOUT__';
        if (pagingParams.withoutTechnicien === 'true') {
            vm.filterTechnicien = vm.WITHOUT_TECHNICIEN;
        }

        vm.techniciens = [];
        Technicien.technicienEnabled({}, function(list) {
            vm.techniciens = list;
        });

        loadAll();

        function loadAll () {
            var params = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            };
            if (vm.filterDate) {
                params.date = DateUtils.convertLocalDateToServer(vm.filterDate);
            }
            if (vm.filterTechnicien === vm.WITHOUT_TECHNICIEN) {
                params.withoutTechnicien = true;
            } else if (vm.filterTechnicien) {
                params.technicien = vm.filterTechnicien;
            }

            FleetDailyTrip.query(params, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fleetDailyTrips = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data ? error.data.message : 'Error');
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function resetFilters() {
            vm.filterDate = null;
            vm.filterTechnicien = '';
            vm.page = 1;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                date: vm.filterDate ? DateUtils.convertLocalDateToServer(vm.filterDate) : null,
                technicien: vm.filterTechnicien && vm.filterTechnicien !== vm.WITHOUT_TECHNICIEN ? vm.filterTechnicien : null,
                withoutTechnicien: vm.filterTechnicien === vm.WITHOUT_TECHNICIEN ? 'true' : null
            }, { reload: true });
        }

        function openCalendar(name) {
            vm.datePickerOpenStatus[name] = true;
        }
    }
})();
